import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=3210a23c&scoped=true&"
import script from "./welfare.vue?vue&type=script&lang=js&"
export * from "./welfare.vue?vue&type=script&lang=js&"
import style0 from "./welfare.vue?vue&type=style&index=0&id=3210a23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3210a23c",
  null
  
)

export default component.exports